import Image from "next/image";
import styled from "styled-components";
import { Button } from "~/guidelines/Button";
import LinkedInIcon from "~/guidelines/Icon/Social/LinkedIn";
import { body2, caption1 } from "~/guidelines/Typography";
import Image1 from "../_assets/team/hugues-van-heesewijk.png";
import Image2 from "../_assets/team/maxime-lesaulnier.png";

const TeamMobileRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
`;

const MemberMobileCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${caption1}
`;

const Name = styled.div`
  ${body2};
  font-weight: 600;
  margin-top: 12px;
  text-align: center;
  margin-bottom: 8px;
`;

const TeamMobile = () => (
  <TeamMobileRow>
    <MemberMobileCard>
      <Image
        src={Image1}
        style={{ width: "100%", height: "100%" }}
        alt="Hugues van Heesewijk"
      />

      <Name>Hugues van Heesewijk</Name>

      <Button kind="tertiary" href="https://www.linkedin.com/in/huguesvanh/">
        <FlexCenter>
          <LinkedInIcon color="#0A33FF" />
          Linked-In
        </FlexCenter>
      </Button>
    </MemberMobileCard>

    <MemberMobileCard>
      <Image
        src={Image2}
        style={{ width: "100%", height: "100%" }}
        alt="Lesaulnier Maxime"
      />

      <Name>Maxime Lesaulnier</Name>

      <Button
        kind="tertiary"
        href="https://www.linkedin.com/in/lesaulnier-maxime-105b8621/"
      >
        <FlexCenter>
          <LinkedInIcon color="#0A33FF" />
          Linked-In
        </FlexCenter>
      </Button>
    </MemberMobileCard>
  </TeamMobileRow>
);

export default TeamMobile;
